// store/slices/menuSlice.js
import { createSlice } from "@reduxjs/toolkit";
import STORAGE, { setStorage } from "src/lib/storage";

const initialState = {
  currentType: localStorage.getItem(STORAGE.MENU_TYPE) || "admin",
};

const menuSlice = createSlice({
  name: "menu",
  initialState,
  reducers: {
    setMenuType: (state, action) => {
      state.currentType = action.payload;
      setStorage(STORAGE.MENU_TYPE, action.payload);
      localStorage.setItem("menu_type", action.payload)
    },
  },
});

export const { setMenuType, setMenuItems } = menuSlice.actions;
export default menuSlice.reducer;
